import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

/**
 * This service is only needed for the LEGACY (Inubit Backend) Version of GOP
 *
 * It's only responsibility is to dynamically load the API URL from a config file
 */

@Injectable()
export class ApiService {
  public cachedApi: string;

  constructor(
    private http: HttpClient
  ) {
  }

  public initialize(): Promise<string> {
    const promise = this.http.get<string>('assets/config/api.json').toPromise();

    promise.then(res => this.cachedApi = res);

    return promise;
  }

}

